import React, { useState, useCallback } from "react";
import SurgeryList from "./Components/SurgeryList";
import AddSurgery from "./Components/AddSurgery";

export default function Surgery() {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSurgeryAdded = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  return (
    <div style={{ padding: "0 20px" }}>
      <div className="col-12" style={{ marginTop: "20px", marginBottom: "20px" }}>
        <div className="d-flex justify-content-end align-items-center">
          <AddSurgery onSurgeryAdded={handleSurgeryAdded} />
        </div>
      </div>
      <div
        key={refreshKey}
        className="col-12"
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "3px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <h5 style={{ fontSize: "18px", fontWeight: "600", color: "#333", marginBottom: "15px" }}>
            All Procedures & Surgeries
          </h5>
        </div>
        <SurgeryList />
      </div>
    </div>
  );
}
